import { inject } from '@angular/core';
import { Auth, user } from '@fido/firebase/auth';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

export const emailVerifiedGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(Auth);

  const u = await firstValueFrom(user(auth));

  if (!u) {
    return router.createUrlTree(['/sign-in']);
  }

  // Check if this is a password-based account
  const isPasswordAccount = u.providerData.some((provider) => provider.providerId === 'password');

  // Only enforce verification for password-based accounts
  if (isPasswordAccount && !u.emailVerified) {
    return router.createUrlTree(['/verify-email']);
  }

  return true;
};
